import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom';
import { BalanceProvider } from './context/BalanceContext';
import { AuthProvider, AuthContext } from './context/AuthContext';

import Header from './components/Header';
import FooterNav from './components/FooterNav';
import SuperAdminRouteGuard from './components/SuperAdminRouteGuard';
import UserRouteGuard from './components/UserRouteGuard';

import HomePage from './pages/Home';
import AppRating from './pages/start';
import DepositPage from './pages/deposit';
import ProfilePage from './pages/profile';
import Transactions from './pages/transactions';
import Records from './pages/records';
import Withdraw from './pages/withdraw';
import WithdrawHistory from './pages/withdraw-history';
import WithdrawInformation from './pages/withdraw-information';
import PersonalInfo from './pages/personal-info';
import About from './pages/about';
import Rules from './pages/rules';
import Forgot from './pages/forgot';
import Login from './pages/login';
import Signup from './pages/signup';
import Notification from './pages/notification';
import InvitationPage from './pages/invitation';

// Admin Components
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Users from './pages/admin/Users';
import DepositRequests from './pages/admin/DepositRequests';
import WithdrawRequests from './pages/admin/WithdrawRequests';
import AppsListing from './pages/admin/AppsListing';
import AddApp from './pages/admin/AddApp';
import Bundles from './pages/admin/Bundles';
import AdminLogin from './pages/admin/AdminLogin';
import DepositAddresses from './pages/admin/DepositAddresses';

function App() {
  return (
    <AuthProvider>
    <BalanceProvider>
        <div className=''>
          <Router>
            {/* Use a component to access location outside Routes */}
            <LocationRenderer />
          </Router>
        </div>
      </BalanceProvider>
      </AuthProvider>
  );
}

// Helper component to render Header and FooterNav conditionally
const LocationRenderer = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAuthRoute = ['/login', '/signup', '/forgot', '/admin/login'].includes(location.pathname);

  const showHeaderAndFooter = !isAdminRoute && !isAuthRoute;

  return (
    <>
      {showHeaderAndFooter && <Header />}
      <main className={showHeaderAndFooter ? 'pt-28' : ''}>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/about" element={<About />} />
          <Route path="/rules" element={<Rules />} />

          {/* Protected User Routes */}
          <Route element={<UserRouteGuard />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/start" element={<AppRating />} />
            <Route path="/deposit" element={<DepositPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/records" element={<Records />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/withdraw-history" element={<WithdrawHistory />} />
            <Route path="/withdraw-information" element={<WithdrawInformation />} />
            <Route path="/personal-info" element={<PersonalInfo />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/invitation" element={<InvitationPage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<SuperAdminRouteGuard />}>
            <Route element={<AdminLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="deposit-requests" element={<DepositRequests />} />
              <Route path="withdraw-requests" element={<WithdrawRequests />} />
              <Route path="deposit-addresses" element={<DepositAddresses />} />
              <Route path="apps" element={<AppsListing />} />
              <Route path="add-app" element={<AddApp />} />
              <Route path="bundles"element={<Bundles />} />
            </Route>
          </Route>
        </Routes>
      </main>
      {showHeaderAndFooter && <FooterNav />}
    </>
  );
}

export default App;
